module.exports = __webpack_public_path__ + "515f15bdbc3b51f7900d822f0a1d2d0a.jpg";